import { Recipe } from '@cooklang/cooklang-ts'
import IngredientList from '~/components/Recipes/IngredientList.tsx'
import RecipeSteps from '~/components/Recipes/RecipeSteps.tsx'
import RecipeImage from './RecipeImage.tsx'
import UserDetails from '../User/UserDetails.tsx'
import type { Recipe as RecipeType, User } from '@prisma/client'

export default function RecipeCard({
	isEmbedded,
	recipe,
	isOwner,
	previewURL,
	user,
}: {
	isEmbedded?: boolean
	recipe: Pick<RecipeType, 'cooklang' | 'title' | 'imageId' | 'notes'>
	isOwner: boolean
	previewURL: string | null | undefined
	user?: Pick<User, 'id' | 'username' | 'imageId' | 'name'>
}) {
	const { title, cooklang, imageId, notes } = recipe
	const cookLang = new Recipe(cooklang, { defaultIngredientAmount: '' })
	console.log('cookLang :>> ', cookLang)
	const { ingredients, steps, cookwares } = cookLang
	// console.log('ingredients :>> ', ingredients)
	// console.log('steps :>> ', steps)
	// Chec
	return (
		<div className="mx-auto max-w-6xl bg-white pb-8">
			{!isOwner && !isEmbedded && (
				<div className="mb-4 flex justify-center">
					<UserDetails user={user} />
				</div>
			)}
			<div className="relative divide-y">
				<h1 className="max-w-3xl p-4 text-center font-sans text-3xl font-medium tracking-wide text-foreground md:text-left md:text-4xl md:leading-tight">
					{title}
				</h1>
				<div className="p-4 md:flex">
					{imageId || previewURL ? (
						// <div className="basis-2/3">
						<div className="w-full">
							<div className="mt-8 flex justify-center">
								{previewURL ? (
									<div className="max-w-lg overflow-hidden border border-secondary p-[1px]">
										<img
											src={previewURL}
											alt={title}
											className="object-cover"
										/>
									</div>
								) : (
									<>
										{imageId && !isEmbedded ? (
											<RecipeImage type="border" publicId={imageId} />
										) : null}
									</>
								)}
							</div>
						</div>
					) : null}
				</div>
			</div>
			<div className="divide-y font-serif text-foreground md:flex md:flex-row md:divide-x md:divide-y-0 md:py-6 lg:pt-8">
				<div className="flex-shrink-0 basis-1/3 px-1 pb-4 font-serif lg:px-4">
					<h2 className="py-2 text-center font-sans text-lg font-semibold tracking-wide md:mb-4 md:text-left md:text-xl">
						Ingredients
					</h2>
					<hr className="mx-auto mb-4 w-3/4 md:mb-0 md:w-0" />
					<IngredientList ingredients={ingredients} />
				</div>
				<div className="md:pl-12 md:pr-4">
					<h2 className="py-2 text-center font-sans text-lg font-semibold tracking-wide sm:text-xl md:mb-4 md:text-left">
						Instructions
					</h2>
					<hr className="mx-auto mb-4 w-3/4 md:mb-0 md:w-0" />
					<RecipeSteps steps={steps} />
				</div>
			</div>
			{cookwares.length > 0 ? (
				<div className="divide-y px-1 md:ml-[33%] md:pl-16 md:pr-4">
					<h3 className="py-2 text-center font-sans text-lg font-semibold tracking-wide sm:text-xl md:text-left">
						Cookware
					</h3>
					<ul className="max-w-prose whitespace-pre-wrap py-4 font-serif text-base capitalize leading-relaxed md:text-lg">
						{cookwares.map(cookware => (
							<li key={cookware.name}>{cookware.name}</li>
						))}
					</ul>
				</div>
			) : null}
			{notes ? (
				<div className="divide-y px-1 md:ml-[33%] md:pl-16 md:pr-4">
					<h3 className="py-2 text-center font-sans text-lg font-semibold tracking-wide sm:text-xl md:text-left">
						Notes
					</h3>
					<div className="max-w-prose whitespace-pre-wrap py-4 font-serif leading-relaxed md:text-lg">
						{notes}
					</div>
				</div>
			) : null}
		</div>
	)
}
